import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/image/qyewm.jpg'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "customer" }
const _hoisted_3 = { class: "iconDiv" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " 联系客服 ", -1)
const _hoisted_5 = { class: "propsDialog" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "CeMeta"),
  /*#__PURE__*/_createElementVNode("span", null, "客户服务顾问")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "有任何商务需求和意见反馈，"),
  /*#__PURE__*/_createElementVNode("p", null, "欢迎联系我们"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "iconBoxApp" }

import { ref ,onMounted} from 'vue';
import {useRoute} from 'vue-router';
import Api from '@/api';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route= useRoute();
const isShow = ref(false);
const alertBox=ref(true);

if(route.path==='/phone'){
    alertBox.value=false;
}
const updatashow = () => {
    isShow.value = true;
};



return (_ctx: any,_cache: any) => {
  const _component_ChatDotSquare = _resolveComponent("ChatDotSquare")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          link: "",
          onClick: updatashow
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ChatDotSquare)
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, !isShow.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_8, 512), [
      [_vShow, isShow.value]
    ]),
    _createVNode(_component_router_view),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_icon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isShow.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Close)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, isShow.value]
    ])
  ]))
}
}

})